<!-- Coming Soon Section -->
<section class="coming-soon-section d-flex align-items-center justify-content-center" style="min-height: calc(100vh - 200px);">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 text-center">
        <div class="coming-soon-content">
          <i class="fa fa-trophy text-primary mb-5" style="font-size: 5rem;"></i>
          <h1 class="display-3 fw-bold mb-4" style="color: #181c32;">Results</h1>
          <h2 class="h3 fw-semibold mb-4" style="color: #009ef7;">Coming Soon</h2>
          <p class="lead text-muted mb-5" style="font-size: 1.25rem; line-height: 1.8;">
            Competition results, standings, and performance statistics will be available here soon.
            Stay tuned for detailed event results and rankings!
          </p>
          <div class="d-flex justify-content-center">
            <a routerLink="/" class="btn btn-primary btn-lg px-5 py-3">
              <i class="fa fa-home me-2"></i>Back to Home
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
